import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/site/Layout";
import { LocaleProvider } from "@/i18n/LocaleContext";
import { LOCALES, pathFor } from "@/i18n/locales";
import Home from "@/pages/Home";
import UeberUns from "@/pages/UeberUns";
import Leistungen from "@/pages/Leistungen";
import Aktuelles from "@/pages/Aktuelles";
import Kontakt from "@/pages/Kontakt";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import NotFound from "@/pages/NotFound";

const PAGES = {
  home: Home,
  about: UeberUns,
  services: Leistungen,
  news: Aktuelles,
  contact: Kontakt,
  imprint: Impressum,
  privacy: Datenschutz,
};

function App() {
  return (
    <BrowserRouter>
      <LocaleProvider>
        <Layout>
          <Routes>
            {LOCALES.flatMap((l) =>
              Object.entries(PAGES).map(([key, Page]) => (
                <Route key={`${l.code}-${key}`} path={pathFor(l.code, key)} element={<Page />} />
              )),
            )}
            {/* Alte URL der Vorgängerseite */}
            <Route path="/uber-uns" element={<Navigate to="/ueber-uns" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors closeButton />
      </LocaleProvider>
    </BrowserRouter>
  );
}

export default App;
